<template>
  <li
    class="flex-col w-full px-0 py-2 rounded-md sm:flex sm:items-start sm:justify-between"
  >
    <div
      class="flex w-full items-center shadow-sm rounded-md dark:bg-[#2e2d38] bg-[#fafafa] min-h-[80px]"
    >
      <div class="flex items-center justify-center px-4">
        <span
          class="inline-flex justify-center items-center w-[40px] h-[40px] rounded-full dark:bg-[#363640] bg-gray-300"
        >
          <svg
            class="w-5 h-5 fill-current stroke-current text-vulcan dark:text-white"
            viewBox="0 0 21 21"
          >
            <g transform="translate(0.7 0.7)">
              <g>
                <g>
                  <g>
                    <path
                      d="M15.855,0a.7.7,0,0,0-.616.364A6.3,6.3,0,0,1,9.8,3.485,6.3,6.3,0,0,1,4.361.364.7.7,0,0,0,3.745,0H.7A.7.7,0,0,0,0,.7V5.6a.7.7,0,0,0,.7.7H18.9a.7.7,0,0,0,.7-.7V.7a.7.7,0,0,0-.7-.7Z"
                      transform="translate(0 13.3)"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      stroke-width="1"
                    />
                    <path
                      id="Path-2"
                      data-name="Path"
                      d="M0,13.3V0H15.4V13.3"
                      transform="translate(2.1)"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      stroke-width="1"
                    />
                    <path
                      id="Path-3"
                      data-name="Path"
                      d="M0,.533H4.2"
                      transform="translate(5.6 3.667)"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      stroke-width="1"
                    />
                    <path
                      id="Path-4"
                      data-name="Path"
                      d="M0,.533H8.4"
                      transform="translate(5.6 6.467)"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      stroke-width="1"
                    />
                    <path
                      id="Path-5"
                      data-name="Path"
                      d="M0,.533H8.4"
                      transform="translate(5.6 9.267)"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      stroke-width="1"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </span>
      </div>
      <div
        class="flex items-center justify-between flex-1 truncate rounded-r-md"
      >
        <div class="flex-1 px-4 py-2 text-sm truncate">
          <a
            title="t('input.preview')"
            href="#"
            @click.prevent="onPreview(item)"
            class="dark:text-white text-[#2d2740] dark:hover:text-gold trans font-medium hover:text-fire"
            >{{ display }}</a
          >
        </div>
        <div class="flex-shrink-0 pr-4 space-x-2">
          <button
            @click="onPreview(item)"
            type="button"
            class="btn--success trans"
          >
            <DocumentTextIcon class="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
            <span v-if="!loading">{{ t("input.btnpreview") }}</span>
            <span v-else class="flex flex-row space-x-4"
              ><span>{{ t("input.saving") }}</span>
              <Spinner text-color="text-black"
            /></span>
          </button>
          <button @click="onDelete(item)" type="button" class="btn--danger">
            <TrashIcon class="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
            <span v-if="!loading">{{ t("input.delete") }}</span>
            <span v-else class="flex flex-row space-x-4"
              ><span>{{ t("input.saving") }}</span>
              <Spinner text-color="text-black"
            /></span>
          </button>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import {
  CheckIcon,
  DocumentTextIcon,
  DotsVerticalIcon,
  PencilIcon,
  TrashIcon,
} from "@heroicons/vue/solid";
import { useI18n } from "vue-i18n";
import Spinner from "../Spinner";

export default {
  name: "FileList",
  components: {
    CheckIcon,
    PencilIcon,
    DotsVerticalIcon,
    TrashIcon,
    Spinner,
    DocumentTextIcon,
  },
  props: {
    type: {
      type: String,
      default: "answer",
    },
    display: {
      type: String,
      default: "",
    },
    application: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
    },
    item: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();

    const onPreview = async (item) => {
      try {
        if (item.file.includes("application_document_placeholder.pdf")) {
          window.open(item.file, "_blank");
          return;
        }
        const params = {
          id: item.id,
          key: item.file,
        };
        let uri;
        switch (props.type) {
          case "af":
            uri = `/applications/${props.application}/files/document`;
            break;
          default:
            uri = "/assets/document";
        }
        const { data } = await axios.post(uri, params);

        const url = data.url;

        window.open(url, "_blank");
      } catch (e) {}
    };

    const onDelete = async (item) => {
      emit("delete", item);
    };

    return {
      t,
      onPreview,
      onDelete,
    };
  },
};
</script>

<style scoped></style>
